(function () {
    'use strict';
    var m = angular.module('settings');
    m.directive('passwordSecurity', ["path", "$q", "configDao", "modals", function (path, $q, configDao, modals) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('settings').directive('password-security').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.isLoading = true;
                $scope.params = {
                    'pwd_expire_enabled': { type: 'boolean' },
                    'pwd_expire_days': {
                        type: 'integer',
                        errorLabel: 'Password expiration period in days'
                    },
                    'pwd_history_enabled': { type: 'boolean' },
                    'pwd_history_length': {
                        type: 'integer',
                        errorLabel: 'Amount of last passwords that can not be used'
                    },
                    'pwd_security_limits': {
                        type: 'object',
                        noSave: true
                    },
                    'pwd_min_length': {
                        type: 'integer',
                        errorLabel: 'Minimum password length',
                        default: 1
                    },
                    'pwd_require_numbers': { type: 'boolean' },
                    'pwd_require_different_case': { type: 'boolean' },
                    'pwd_require_special_chars': { type: 'boolean' }
                };
                $scope.model = {};
                function parseParamValue(paramInfo, value) {
                    if (paramInfo.type === 'integer') {
                        if (_(value).isNull()) {
                            return paramInfo.default || 0;
                        } else {
                            return parseInt(value);
                        }
                    }
                    if (paramInfo.type === 'boolean') {
                        return !!value;
                    }
                    return value;
                }
                $q.all(_($scope.params).map(function (paramInfo, param) {
                    paramInfo.error = false;
                    return configDao.param(param).then(function (value) {
                        $scope.model[param] = parseParamValue(paramInfo, value);
                    });
                })).then(function () {
                    $scope.isLoading = false;
                }, function (error) {
                    $scope.isLoading = false;
                    $scope.model.error = 'Failed to load configuration';
                });
                $scope.save = function () {
                    var errors = validate();
                    if (errors.length) {
                        return modals.alert(errors, { title: 'Error' });
                    }
                    $scope.isLoading = true;
                    $q.all(_($scope.params).chain().pick(function (paramInfo) {
                        return !paramInfo.noSave;
                    }).map(function (paramInfo, param) {
                        return configDao.setParam(param, $scope.model[param]);
                    }).value()).then(function () {
                        $scope.isLoading = false;
                    }, function (error) {
                        $scope.isLoading = false;
                        return modals.alert('Failed to save password security policy configuration', { title: 'Save error' });
                    });
                };
                function validationTextAndStatus(param, value) {
                    if (!$scope.model || !$scope.model.pwd_security_limits || !$scope.model.pwd_security_limits[param]) {
                        return null;
                    }
                    var limits = $scope.model.pwd_security_limits[param];
                    if (!_(limits.min).isUndefined() && !_(limits.max).isUndefined()) {
                        return {
                            text: 'should be in the range from ' + limits.min + ' to ' + limits.max,
                            isValid: value >= limits.min && value <= limits.max
                        };
                    }
                    if (!_(limits.min).isUndefined()) {
                        return {
                            text: 'should be equal to or greater than ' + limits.min,
                            isValid: value >= limits.min
                        };
                    }
                    if (!_(limits.max).isUndefined()) {
                        return {
                            text: 'should be equal to or less than ' + limits.max,
                            isValid: value <= limits.max
                        };
                    }
                    return null;
                }
                function validate() {
                    var errors = [];
                    _($scope.params).each(function (paramInfo, paramName) {
                        paramInfo.error = false;
                        var validationData = validationTextAndStatus(paramName, $scope.model[paramName]);
                        if (!validationData) {
                            return;
                        }
                        if (!validationData.isValid) {
                            paramInfo.error = paramInfo.errorLabel + ' ' + validationData.text;
                            errors.push(paramInfo.error);
                        }
                    });
                    return errors;
                }
                $scope.passwordSecurityTip = function (param) {
                    var validationData = validationTextAndStatus(param);
                    if (!validationData || !validationData.text) {
                        return null;
                    }
                    return 'Value ' + validationData.text;
                };
            }
        };
    }]);
}());